import React, {useState, useEffect} from "react";
// import useFetch from '../utils/useFetch.js';
import useForceUpdate from "../utils/update.js";
import Card from './card.js';

export default function Directory() {

  // const people = useFetch('/wp-json/wp/v2/employees?_embed&per_page=100&orderby=title&order=asc');
  // const depts  = useFetch('/wp-json/wp/v2/department?per_page=100');
  const [people, setPeople] = useState (null);
  const [depts, setDepts] = useState (null);
  const [loading, setLoading] = useState(true);
  const [deptChoice, setDeptChoice] = useState('');
  const [employeeName, setEmployeeName] = useState('');

  useEffect(() => {
    console.log("deptchoice useefect in directory");
    console.log(deptChoice);
  }, [deptChoice]);

  useEffect(() => {
    async function fetchData() {
      try {
        const [peopleResponse, deptResponse] = await Promise.all([
          fetch('/wp-json/wp/v2/employees?_embed&per_page=100&_fields=acf,title,department,_links.wp:featuredmedia&orderby=title&order=asc'),
          fetch('/wp-json/wp/v2/department?per_page=100')
        ]);

        const peopleData = await peopleResponse.json();
        const deptData = await deptResponse.json();

        setPeople(peopleData);
        setDepts(deptData);
      } catch (error) {
        console.error('Error fetching data: ', error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  function handleDeptChange(e) {
    setDeptChoice(e.target.value);
    setEmployeeName('');
  }

  function handleNameChange(e) {
    setEmployeeName(e.target.value);
    setDeptChoice(0);
  }

  if (loading) {
    return (
      <div class="fadein">
        <Header deptChoice={deptChoice} employeeName={employeeName} onDeptChange={handleDeptChange} onNameChange={handleNameChange} depts={depts}/>
        <div className="directory-people-repeater">
          <h3 className="text-center">Loading...</h3>
        </div>
      </div>
    );
  }

  return(
    <div class="fadein">
      <Header deptChoice={deptChoice} employeeName={employeeName} onDeptChange={handleDeptChange} onNameChange={handleNameChange} depts={depts}/>
      <div className="directory-people-repeater">
        <div className="wrap directory-people">
          {people && people.map((person, index) => (
            <Card key={index} data={person} deptImport={depts} deptChoice={deptChoice} employeeName={employeeName} />
          ))}
        </div>
      </div>
    </div>
  ); 
}

function Header({deptChoice, employeeName, onDeptChange, onNameChange, depts}) {

  return(
    
    <div className="directory-search-container">
      <div className="wrap directory-search-head">
        <h2>Find Your Kraft Contact</h2>
        <div className="directory-search">
          {/* <select name="department" id="department-select" defaultValue={0} value={deptFilter} onChange={handleChange} > */}
          {/* <input value={employeeName} onChange={onNameChange}></input> */}
          <label hidden for="department">Filter directory by department</label>
          <select name="department" id="department-select" defaultValue={0} value={deptChoice} onChange={onDeptChange} >
            <option value="0">All Departments</option>
            {depts && depts.map((department, index) => (
            <option value={department.id}>{department.name}</option>
            ))}
          </select>
          <label hidden for="name-search">Search directory by name</label><input value={employeeName} onChange={onNameChange} type="search" id="name-search" name="name-search" placeholder="Search by Name"/><button><img alt="magnifying glass" className="search-icon" src="/wp-content/uploads/2024/03/icon-search.svg"/></button>
        </div>
      </div>
    </div>
    );
  }
